import { ChevronLeft, ChevronRight, MoreHorizontal } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { cn } from '@/shared/lib/utils'

function Pagination({ className, ...props }) {
  return (
    <nav
      role="navigation"
      aria-label="pagination"
      className={cn('mx-auto flex w-full justify-center', className)}
      {...props}
    />
  )
}

function PaginationContent({ className, ...props }) {
  return (
    <ul
      className={cn(
        'flex flex-row flex-wrap items-center justify-center gap-1',
        className,
      )}
      {...props}
    />
  )
}

function PaginationItem({ className, ...props }) {
  return <li className={cn('', className)} {...props} />
}

function PaginationLink({ className, isActive, size = 'icon', ...props }) {
  return (
    <Button
      type="button"
      variant={isActive ? 'navy' : 'outline'}
      size={size}
      aria-current={isActive ? 'page' : undefined}
      className={cn(
        'size-8 rounded-full text-xs font-semibold sm:size-9',
        !isActive &&
          'border-black/[0.08] bg-white text-foreground hover:bg-muted',
        className,
      )}
      {...props}
    />
  )
}

function PaginationPrevious({ className, ...props }) {
  return (
    <Button
      type="button"
      variant="outline"
      className={cn(
        'h-8 gap-1 rounded-full border-black/[0.08] bg-white px-2.5 text-xs font-semibold sm:h-9 sm:px-3',
        className,
      )}
      {...props}
    >
      <ChevronLeft className="size-4" />
      <span className="hidden sm:inline">Previous</span>
    </Button>
  )
}

function PaginationNext({ className, ...props }) {
  return (
    <Button
      type="button"
      variant="outline"
      className={cn(
        'h-8 gap-1 rounded-full border-black/[0.08] bg-white px-2.5 text-xs font-semibold sm:h-9 sm:px-3',
        className,
      )}
      {...props}
    >
      <span className="hidden sm:inline">Next</span>
      <ChevronRight className="size-4" />
    </Button>
  )
}

function PaginationEllipsis({ className, ...props }) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-8 items-center justify-center text-muted-foreground sm:size-9',
        className,
      )}
      {...props}
    >
      <MoreHorizontal className="size-4" />
      <span className="sr-only">More pages</span>
    </span>
  )
}

export {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationPrevious,
  PaginationNext,
  PaginationEllipsis,
}
